export default __webpack_public_path__ + "static/media/Asset 5_11zon.22a4bfe0.webp";